import { Component } from '@angular/core';

import {
	NavController,
	LoadingController,
	IonicPage,
	NavParams,
	ToastController
} from 'ionic-angular';


import { AuthProvider } from '../../providers/auth/auth';
import { AddressProvider } from '../../providers/address/address';

import { Address, User, AddressOwnerType, Condominium, AddressType } from '../../models/models';

/**
Parametri:

- user owner, solo se owner user
- user_id id owner, solo se user null
- user_type tipo owner, solo se user null
- title titolo, default determinato da type
- priority priorità negli elenchi
- isPriorityWritable, flag per permettere edit priorità, default false
- type tipo indirizzo
- isTypeWritable, flag per permettere edit tipo, default false
*/
@IonicPage()
@Component({
	selector: 'page-address-create',
	templateUrl: 'address-create.html',
})
export class AddressCreatePage {
	public title: string = null;
	public isPriorityWritable: boolean = false;
	public isTypeWritable: boolean = false;
	public loading: any;

	public condominium: Condominium = null;
	public user: User = null;

	public address: Address = <Address>{
		type: AddressType.LOCATION,
		location: null,
		owner: null,
		user: null,
	};

	constructor(
		public addresses: AddressProvider,
		public auth: AuthProvider,
		public loadingCtrl: LoadingController,
		public navCtrl: NavController,
		public navParams: NavParams,
		public toastCtrl: ToastController
	) {
		if (this.user = navParams.get('user')) {
			console.debug('[AddressCreatePage.constructor()] Creazione di Address per User', this.user);
			this.address.owner_type = 'App\\User';
			this.address.owner_id = this.auth.id;
		} else if (this.condominium = navParams.get('condominium')) {
			console.debug('[AddressCreatePage.constructor()] Creazione di Address per Condominium', this.condominium);
			this.address.owner_type = 'App\\Condominium';
			this.address.owner_id = this.condominium.id;
		} else {
			console.warn('[AddressCreatePage.constructor()] Creazione di Address senza tipo owner implicito', navParams.data);
			this.address.owner_type = navParams.get('ownerType');
			this.address.owner_id = navParams.get('ownerId');
		}


		//type
		let type: AddressType = navParams.get('type');
		if (type) {
			this.address.type = type;
		}
		let isTypeWritable = navParams.get('isTypeWritable')
		if (isTypeWritable || isTypeWritable === false) {
			this.isTypeWritable = isTypeWritable;
		}

		if (!(this.title = navParams.get('title'))) {
			switch (this.address.type) {
				case AddressType.CONTACT:
					this.title = "Crea contatto";
					break;
				case AddressType.LOCATION:
					this.title = "Crea indirizzo";
					break;
			}
		}

		//priority
		let priority = navParams.get('priority');
		if (priority) {
			this.address.priority = priority;
		}

		let isPriorityWritable = navParams.get('isPriorityWritable')
		if (isPriorityWritable || isPriorityWritable === false) {
			this.isPriorityWritable = isPriorityWritable;
		}
	}

	public save() {
		let self = this;
		this.loading = this.loadingCtrl.create({
			content: 'Salvataggio in corso...',
			dismissOnPageChange: false
		});
		this.loading.present();
		this.addresses.save(this.address).subscribe(
			(address: Address) => {
				self.loading.dismiss();
				console.debug("Indirizzo creato: ", address);
				let toast = self.toastCtrl.create({
					message: self.address.type == AddressType.LOCATION ? 'Nuovo indirizzo salvato' : 'Nuovo contatto salvato',
					position: 'middle',
					duration: 3000
				});
				toast.present();
				self.navCtrl.pop();
			},
			(error: any) => {
				self.loading.dismiss();
				console.error("Errore creando l'indirizzo:", error);
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/address-create/address-create.ts